import React, { useState, useEffect } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";

const DodajNovice = () => {
    const [ime, setIme] = useState("");
    const [podnaslov, setPodnaslov] = useState("");
    const [datum, setDatum] = useState("");
    const [slike, setSlike] = useState([]);
    const [pdfji, setPdfji] = useState([]);
    const [sekcije, setSekcije] = useState([
        { podnaslov: "", datum: "", vsebina: [] },
    ]);

    const [seShranjuje, setSeShranjuje] = useState(false);
    const [novice, setNovice] = useState([]);
    const [urejanjeId, setUrejanjeId] = useState(null);
    const [potrdiBrisanjeId, setPotrdiBrisanjeId] = useState(null);

    useEffect(() => {
        fetchNovice();
    }, []);

    const fetchNovice = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/novice`);
            const data = await res.json();
            setNovice(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Napaka pri pridobivanju novic:", err);
        }
    };

    const handleSlikeChange = (e) => setSlike([...e.target.files]);
    const handlePdfChange = (e) => setPdfji([...e.target.files]);

    // 🧩 Sekcije
    const dodajSekcijo = () => {
        setSekcije([...sekcije, { podnaslov: "", datum: "", vsebina: [] }]);
    };

    const odstraniSekcijo = (i) => {
        const updated = sekcije.filter((_, idx) => idx !== i);
        setSekcije(updated);
    };

    const handleSekcijaChange = (i, field, value) => {
        const updated = [...sekcije];
        updated[i][field] = value;
        setSekcije(updated);
    };

    // 🧱 Dodaj element v sekcijo (odstavek, link, pdf, slika)
    const dodajElement = (sekIndex, tip) => {
        const updated = [...sekcije];
        const noviElement =
            tip === "link"
                ? { tip, naslov: "", url: "" }
                : tip === "odstavek"
                    ? { tip, vsebina: "" }
                    : { tip, url: "" };
        updated[sekIndex].vsebina.push(noviElement);
        setSekcije(updated);
    };

    const odstraniElement = (sekIndex, elIndex) => {
        const updated = [...sekcije];
        updated[sekIndex].vsebina.splice(elIndex, 1);
        setSekcije(updated);
    };

    const handleElementChange = (sekIndex, elIndex, field, value) => {
        const updated = [...sekcije];
        updated[sekIndex].vsebina[elIndex][field] = value;
        setSekcije(updated);
    };

    const handleElementFile = (sekIndex, elIndex, e) => {
        const updated = [...sekcije];
        updated[sekIndex].vsebina[elIndex].file = e.target.files[0];
        setSekcije(updated);
    };

    // 📨 Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSeShranjuje(true);

        const formData = new FormData();
        formData.append("ime", ime);
        formData.append("podnaslov", podnaslov);
        formData.append("datum", datum);

        // Pretvorimo sekcije brez datotek
        const sekcijeZaPoslati = sekcije.map((s) => ({
            podnaslov: s.podnaslov,
            datum: s.datum,
            vsebina: s.vsebina.map((v) => {
                const obj = { tip: v.tip };
                if (v.tip === "odstavek") obj.vsebina = v.vsebina;
                if (v.tip === "link") {
                    obj.naslov = v.naslov;
                    obj.url = v.url;
                }
                if ((v.tip === "slika" || v.tip === "pdf") && v.url) {
                    obj.url = v.url;
                }
                return obj;
            }),
        }));

        formData.append("sekcije", JSON.stringify(sekcijeZaPoslati));

        // Glavne slike in pdfji
        slike.forEach((f) => formData.append("slike", f));
        pdfji.forEach((f) => formData.append("pdfji", f));

        // Datoteke iz sekcij
        sekcije.forEach((s) =>
            s.vsebina.forEach((v) => {
                if (v.tip === "slika" && v.file) formData.append("slike", v.file);
                if (v.tip === "pdf" && v.file) formData.append("pdfji", v.file);
            })
        );

        try {
            const url = urejanjeId
                ? `${process.env.REACT_APP_BACKEND_URL}/novice/${urejanjeId}`
                : `${process.env.REACT_APP_BACKEND_URL}/novice/dodaj`;
            const method = urejanjeId ? "PUT" : "POST";

            const res = await fetch(url, { method, body: formData });
            if (res.ok) {
                alert(urejanjeId ? "✅ Novica posodobljena!" : "✅ Novica dodana!");
                resetForm();
                fetchNovice();
            } else {
                const err = await res.json();
                alert("Napaka: " + err.message);
            }
        } catch (err) {
            console.error("Napaka:", err);
            alert("Napaka pri pošiljanju.");
        } finally {
            setSeShranjuje(false);
        }
    };

    const resetForm = () => {
        setIme("");
        setPodnaslov("");
        setDatum("");
        setSlike([]);
        setPdfji([]);
        setSekcije([{ podnaslov: "", datum: "", vsebina: [] }]);
        setUrejanjeId(null);
    };

    const naloziZaUrejanje = async (id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/novice/${id}`);
            const data = await res.json();
            setIme(data.ime || "");
            setPodnaslov(data.podnaslov || "");
            setDatum(data.datum?.slice(0, 16) || "");
            setSekcije(data.sekcije || []);
            setUrejanjeId(id);
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (err) {
            console.error("Napaka pri nalaganju novice:", err);
        }
    };

    const izbrisiNovico = async (id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/novice/${id}`, {
                method: "DELETE",
            });
            if (res.ok) {
                alert("🗑️ Novica izbrisana!");
                setNovice(novice.filter((n) => n._id !== id));
            } else {
                const err = await res.json();
                alert("Napaka: " + err.message);
            }
        } catch (err) {
            console.error("Napaka pri brisanju:", err);
        } finally {
            setPotrdiBrisanjeId(null);
        }
    };

    return (
        <div>
            <div className="dodaj-koncert">
                <h2>{urejanjeId ? "Uredi Novico" : "Dodaj Novico"}</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Naslov"
                        value={ime}
                        onChange={(e) => setIme(e.target.value)}
                        required
                    />
                    <input
                        type="text"
                        placeholder="Podnaslov"
                        value={podnaslov}
                        onChange={(e) => setPodnaslov(e.target.value)}
                    />
                    <input
                        type="datetime-local"
                        value={datum}
                        onChange={(e) => setDatum(e.target.value)}
                        required
                    />

                    {sekcije.map((sekcija, sekIndex) => (
                        <div key={sekIndex} className="sekcija">
                            <h3>Sekcija</h3>
                            <input
                                type="text"
                                placeholder="Podnaslov sekcije"
                                value={sekcija.podnaslov}
                                onChange={(e) =>
                                    handleSekcijaChange(sekIndex, "podnaslov", e.target.value)
                                }
                            />
                            <input
                                type="datetime-local"
                                value={sekcija.datum}
                                onChange={(e) =>
                                    handleSekcijaChange(sekIndex, "datum", e.target.value)
                                }
                            />

                            <h4 className="vsebina-sekcije">Vsebina</h4>
                            {sekcija.vsebina.map((el, elIndex) => (
                                <div key={elIndex} className="vsebina-element">
                                    <strong>{el.tip}</strong>

                                    {el.tip === "odstavek" && (
                                        <textarea
                                            className="proba-textarea"
                                            value={el.vsebina}
                                            placeholder="Besedilo odstavka"
                                            onChange={(e) =>
                                                handleElementChange(
                                                    sekIndex,
                                                    elIndex,
                                                    "vsebina",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    )}

                                    {el.tip === "link" && (
                                        <>
                                            <input
                                                className="proba-textarea"
                                                type="text"
                                                placeholder="Naslov povezave"
                                                value={el.naslov}
                                                onChange={(e) =>
                                                    handleElementChange(
                                                        sekIndex,
                                                        elIndex,
                                                        "naslov",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            <input
                                                className="proba-textarea"
                                                type="text"
                                                placeholder="URL"
                                                value={el.url}
                                                onChange={(e) =>
                                                    handleElementChange(
                                                        sekIndex,
                                                        elIndex,
                                                        "url",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </>
                                    )}

                                    {(el.tip === "slika" || el.tip === "pdf") && (
                                        <input
                                            className="proba-textarea"
                                            type="file"
                                            accept={el.tip === "pdf" ? "application/pdf" : "image/*"}
                                            onChange={(e) => handleElementFile(sekIndex, elIndex, e)}
                                        />
                                    )}

                                    <button
                                        className="odstrani mal-paddinga"
                                        type="button"
                                        onClick={() => odstraniElement(sekIndex, elIndex)}
                                    >
                                        Odstrani
                                    </button>
                                </div>
                            ))}

                            <div className="dodaj-vsebino">
                                <button className="dodaj-gumb" type="button" onClick={() => dodajElement(sekIndex, "odstavek")}>
                                    + Odstavek
                                </button>
                                <button className="dodaj-gumb" type="button" onClick={() => dodajElement(sekIndex, "link")}>
                                    + Link
                                </button>
                                <button className="dodaj-gumb" type="button" onClick={() => dodajElement(sekIndex, "slika")}>
                                    + Slika
                                </button>
                                <button className="dodaj-gumb" type="button" onClick={() => dodajElement(sekIndex, "pdf")}>
                                    + PDF
                                </button>
                            </div>

                            <button type="button" className="odstrani" onClick={() => odstraniSekcijo(sekIndex)}>
                                Izbriši sekcijo
                            </button>
                        </div>
                    ))}

                    <button type="button" onClick={dodajSekcijo}>
                        + Dodaj sekcijo
                    </button>

                    <h3>Glavne slike</h3>
                    <input type="file" multiple accept="image/*" onChange={handleSlikeChange} />
                    <h3>PDF datoteke</h3>
                    <input type="file" multiple accept="application/pdf" onChange={handlePdfChange} />

                    {seShranjuje && <p style={{ color: "green" }}>Shranjujem...</p>}
                    <button type="submit">{urejanjeId ? "Shrani spremembe" : "Shrani novico"}</button>
                </form>
            </div>

            <div className="center">
                <div>
            <h2 style={{ marginTop: "2em" }}>Urejanje novic</h2>
            <div className="seznam-novic">
                {novice.map((n) => (
                    <div key={n._id} className="spreminjanje-koncertov-karta">
                        {n.slike && n.slike[0] && (
                            <img
                                src={n.slike[0]}
                                alt={n.ime}
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                }}
                            />
                        )}
                        <div style={{ flex: 1 }}>
                            <h3>{n.ime}</h3>
                        </div>
                        <div>
                            <button onClick={() => naloziZaUrejanje(n._id)}>
                                <FaRegEdit /> Uredi
                            </button>
                            <button onClick={() => setPotrdiBrisanjeId(n._id)} className="izbris-gumb">
                                <MdDeleteOutline /> Odstrani
                            </button>
                        </div>
                    </div>
                ))}
            </div>
                </div>
            </div>

            {potrdiBrisanjeId && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>A si prepričan, da želiš izbrisati to novico?</h3>
                        <div className="modal-buttons">
                            <button className="potrdi" onClick={() => izbrisiNovico(potrdiBrisanjeId)}>
                                Da
                            </button>
                            <button className="preklici" onClick={() => setPotrdiBrisanjeId(null)}>
                                Ne
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DodajNovice;
